"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SocialSigninCard;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.promise.js");
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _universalCookie = _interopRequireDefault(require("universal-cookie"));
var _analytics = require("firebase/analytics");
var _googleLogo = _interopRequireDefault(require("../../files/googleLogo.png"));
var _AcceptGTCU = _interopRequireDefault(require("./AcceptGTCU"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function SocialSigninCard(props) {
  const {
    afterSignInRedirect,
    t,
    analytics,
    navigate,
    Link,
    gtcuCookieName,
    ourSignInWithPopup,
    signinCallback = () => {}
  } = props;
  const cookies = new _universalCookie.default();
  const [acceptedGTCU, setacceptedGTCU] = _react.default.useState(false);
  const [showGTCUError, setshowGTCUError] = _react.default.useState(false);
  const signIn = async () => {
    if (!acceptedGTCU) {
      return setshowGTCUError(true);
    }
    localStorage.setItem(gtcuCookieName, 'true');
    cookies.set(gtcuCookieName, 'true');
    try {
      const result = await ourSignInWithPopup();
      signinCallback();
      if (!afterSignInRedirect) {
        navigate('/');
      } else {
        navigate(afterSignInRedirect);
      }
      return result;
    } catch (error) {
      (0, _analytics.logEvent)(analytics, 'login_error', {
        error_message: error.message
      });
    }
    return null;
  };
  return /*#__PURE__*/_react.default.createElement(_material.Card, {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      p: 3,
      gap: 1,
      width: {
        xs: '100%',
        sm: '88%'
      },
      maxWidth: 670
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    component: "span",
    variant: "subtitle1",
    gutterBottom: true
  }, t('signin.google_login')), /*#__PURE__*/_react.default.createElement(_AcceptGTCU.default, {
    acceptedGTCU: acceptedGTCU,
    setacceptedGTCU: setacceptedGTCU,
    showGTCUError: showGTCUError,
    setshowGTCUError: setshowGTCUError,
    t: t,
    Link: Link
  }), /*#__PURE__*/_react.default.createElement(_material.Button, {
    variant: "contained",
    color: "inherit",
    onClick: signIn
  }, /*#__PURE__*/_react.default.createElement("img", {
    style: {
      width: 20,
      marginRight: 5
    },
    src: _googleLogo.default,
    alt: "Google Labox"
  }), t('signin.login')));
}